import React, { useCallback, useEffect, useState } from 'react';
import SEO from '../utils/SEO';

import PropTypes from 'prop-types';

import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';

import { ArtistPopUp, ArtistsListingCards } from '../components';
import { Link } from 'react-router-dom';
import { animateScroll } from 'react-scroll';
import { useLocation } from 'react-router';

import './../assets/styles/pages/_artists-listing.scss';
import ScrollToButton from '../components/common/scrollToButton/scrollToButton';
import LeftNavigationMenu from '../components/complex/leftNavigationMenu/leftNavigationMenu';
import { tools } from '../utils';
import { startLoader } from '../components/common/Loader';
import SVGLoader from '../components/common/SVGLoader/SVGLoader';

const ArtistsListing = ({ match, getArtists, ...props }) => {
  const [allData, setAllData] = useState(null);
  const [artists, setArtists] = useState(null);
  const [conductors, setConductors] = useState(null);
  const [orchestras, setOrchestras] = useState(null);
  const [types, setTypes] = useState(null);
  const [artist, setArtist] = useState(null);
  const [banner, setBanner] = useState(null);
  const [dataReady, setDataReady] = useState(false);
  const location = useLocation();

  useEffect(() => {
    props.getMeta('Artists');
    startLoader();
  }, []);

  const getCoords = useCallback((elem) => {
    const box = elem.getBoundingClientRect();

    const { body } = document;
    const docEl = document.documentElement;

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const clientTop = docEl.clientTop || body.clientTop || 0;

    const top = box.top + scrollTop - clientTop;

    return { top: Math.round(top) };
  }, []);

  useEffect(() => {
    getArtists().then((response) => {
      const soloists = response.res.data.filter((el) => el.role === 'soloist');
      const conductors = response.res.data.filter(
        (el) => el.role === 'conductor'
      );
      const orchestras = response.res.data.filter(
        (el) => el.role === 'orchestra'
      );
      const types = [
        response.res.data.find((el) => el.role === 'soloist') && {
          id: 1,
          type: 'soloists',
        },
        response.res.data.find((el) => el.role === 'conductor') && {
          id: 2,
          type: 'conductors',
        },
        response.res.data.find((el) => el.role === 'orchestra') && {
          id: 3,
          type: 'orchestras',
        },
      ];
      setAllData(response.res.data);
      setArtists(soloists);
      setConductors(conductors);
      setOrchestras(orchestras);
      setTypes(types);
      setBanner(response.res.banner);
    });
  }, [match.params.url, getArtists]);
  useEffect(() => {
    allData &&
      artists &&
      conductors &&
      orchestras &&
      types &&
      setDataReady(true);
  }, [allData, artists, conductors, orchestras, types]);

  const openPopup = useCallback((artist) => {
    setArtist(artist);
    window.location.hash =
      artist.role === 'orchestra'
        ? `${artist.name.split(' ').join('_')}`
        : `${artist.name}_${artist.surname}`;
  }, []);

  function closePopup () {
    setArtist(null);
  }

  useEffect(() => {
    function scrollToElement () {
      const params = new URL(document.location);
      const activeLink = params.searchParams.get('active');

      const headLine = document.getElementById('headLine').offsetHeight;
      const offsetPos = headLine ? headLine * 3 : 0;

      if (activeLink) {
        const pos =
          document.getElementById(activeLink) &&
          getCoords(document.getElementById(activeLink)).top;
        animateScroll.scrollTo(pos - offsetPos, { duration: 1500 });
      }
    }
    dataReady && setTimeout(() => scrollToElement(true), 1500);
  }, [location.search, dataReady, getCoords]);

  useEffect(() => {
    const artistHash = window.location.hash
      .replace('#', '')
      .split('_')
      .join(' ');
    if (artistHash && dataReady) {
      for (const [key, value] of Object.entries(allData)) {
        const currentArtist =
          value.role === 'orchestra'
            ? value.name === artistHash && value
            : `${value.name} ${value.surname}` === artistHash && value;
        if (currentArtist) {
          setArtist(currentArtist);
          break;
        }
      }
    }
  }, [location.hash, dataReady, allData]);
  const metaData = props.metaData?.res;
  const bannerIMG =
    props.artists_list &&
    props.artists_list.items &&
    props.artists_list.items.banner;
  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />
      <ArtistPopUp
        artist={artist}
        onClose={closePopup}
        className={artist ? 'show' : ''}
      />

      <div className='listing__content'>
        <section
          className='listing__banner'
          id='listing__banner'
          style={{ backgroundColor: '#000e45' }}
        >
          <div
            style={{ backgroundImage: `url(${bannerIMG && bannerIMG.url})` }}
            className='banner-img d-none d-md-block'
          >
            <Link to='/' className='banner-logo'>
              <img src='/media/images/Logo.png' alt='logo' />
            </Link>
            <ScrollToButton
              duration={1500}
              elementId='listing__artists'
              offset={
                tools.canUseDOM && document.getElementById('headLine')
                  ? -document.getElementById('headLine').offsetHeight
                  : ''
              }
            />
          </div>
          <div
            style={{
              backgroundImage: `url(${bannerIMG && bannerIMG.mobile_url})`,
            }}
            className='banner-img d-md-none d-block'
          >
            <Link to='/' className='banner-logo'>
              <img src='/media/images/Logo.png' alt='logo' />
            </Link>
            <ScrollToButton
              duration={1500}
              elementId='listing__artists'
              offset={
                tools.canUseDOM && document.getElementById('headLine')
                  ? -document.getElementById('headLine').offsetHeight
                  : ''
              }
            />
          </div>
        </section>
        {props.artists_list.loading ? (
          <div
            style={{
              textAlign: ' center',
              minHeight: '300px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <SVGLoader />
          </div>
        ) : (
          <section className='listing__artists fadeIn' id='listing__artists'>
            <LeftNavigationMenu data={types} getCoords={getCoords} />

            <div className='listing__details'>
              {types &&
                types.length &&
                types.map((type) => (
                  <div
                    key={type.id}
                    className='listing__details__section'
                    id={type.type}
                  >
                    <h2 key={type.id} className={`listing__title ${type.type}`}>
                      {type.type}
                    </h2>
                    <div className='artists' data-type={type.type}>
                      <ArtistsListingCards
                        artists={
                          type.type === 'soloists'
                            ? artists
                            : type.type === 'conductors'
                            ? conductors
                            : orchestras
                        }
                        openPopup={openPopup}
                        type={type.type}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

function mapState (state) {
  return {
    artists_list: state.getArtists,
    metaData: state.getMeta,
  };
}

ArtistsListing.propTypes = {
  match: PropTypes.object,
  getArtists: PropTypes.func,
  artists_list: PropTypes.object,
};

const actionCreators = {
  getArtists: userActions.getArtists,
  getMeta: userActions.getMetaData,
};
ArtistsListing.fetchMeta = () => actionCreators.getMeta('Artists');
ArtistsListing.serverFetch = actionCreators.getArtists;
export default connect(mapState, actionCreators)(ArtistsListing);
